import { useEffect, useState } from "react";
import { Type } from "lucide-react";

/* Density tuner — three `A` buttons (small · default · large) that write
   `data-density="sm|md|lg"` on <html>. Persists in localStorage.tp_density
   so it survives reloads. Root font-size overrides in index.css scale every
   Tailwind `text-*` class. Used in the Footer and Navbar utility row so
   accessibility-first users don't have to scroll to find the control. */
const DENSITIES = [
  { key: "sm", label: "A", title: "Smaller text",  size: "text-[10px]" },
  { key: "md", label: "A", title: "Default text",  size: "text-xs" },
  { key: "lg", label: "A", title: "Larger text",   size: "text-sm" },
];

export default function DensityTuner({ testid = "density-tuner", compact = false }) {
  const [density, setDensity] = useState(() => {
    try { return localStorage.getItem("tp_density") || "md"; } catch { return "md"; }
  });
  useEffect(() => {
    document.documentElement.dataset.density = density;
    try { localStorage.setItem("tp_density", density); } catch { /* silent */ }
  }, [density]);
  return (
    <div className="inline-flex items-center gap-1" role="group" aria-label="Text size"
      data-testid={testid}>
      {!compact && <Type className="w-3.5 h-3.5 text-accent" />}
      {DENSITIES.map((d) => (
        <button key={d.key} onClick={() => setDensity(d.key)}
          data-testid={`${testid}-${d.key}`}
          aria-label={d.title} title={d.title} aria-pressed={density === d.key}
          className={`${d.size} font-serif font-800 min-w-[26px] min-h-[26px] px-1 rounded transition-colors ${
            density === d.key
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-primary hover:bg-muted"
          }`}>
          {d.label}
        </button>
      ))}
    </div>
  );
}
